import { render } from "./SCR050.vue?vue&type=template&id=a8d2390e"
import script from "./SCR050.vue?vue&type=script&lang=ts"
export * from "./SCR050.vue?vue&type=script&lang=ts"
script.render = render

export default script